import { Calendar, Trash2, Zap } from 'lucide-react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MyInput from '../../components/MyComponent/MyInput';
import { calculateBillSummary } from '../../utils/utils';
import { setDataAction } from '../../redux/Actions/SetDataAction';
import { SET_BILLING_AUTOBILL_DATA } from '../../redux/ActionName/ActionName';

export const AutoBillingSection = () => {
    const BillingReducer = useSelector((state) => state.BillingReducer);
    const dispatch = useDispatch();

    const handleAutoBillChange = (type, value, index) => {
        let oldData = [...(BillingReducer?.selectedAutoBills || [])];

        if (type === 'removeAutoBill') {
            oldData = [...oldData.slice(0, index), ...oldData.slice(index + 1)];
        } else {
            if (type === 'selectFrequency') {
                oldData[index] = { ...oldData[index], frequency: value };
            } else if (type === 'changeStartDate') {
                oldData[index] = { ...oldData[index], startDate: value };
            } else if (type === 'changeEndDate') {
                oldData[index] = { ...oldData[index], endDate: value };
            } else if (type === 'changeAmount') {
                if (value !== '' && !/^(?:[0-9]+(?:\.[0-9]*)?)?$/.test(value)) return;
                oldData[index] = { ...oldData[index], amount: value, total: value };
            } else if (type === 'changeDescription') {
                oldData[index] = { ...oldData[index], description: value };
            }
        }

        dispatch(setDataAction(oldData, SET_BILLING_AUTOBILL_DATA));
        const updatedBillingReducer = { ...BillingReducer, selectedAutoBills: oldData };
        calculateBillSummary(updatedBillingReducer, dispatch);
    };

    const frequencyOptions = [
        { label: 'Daily', value: 'daily' },
        { label: 'Weekly', value: 'weekly' },
        { label: 'Monthly', value: 'monthly' },
        { label: 'Yearly', value: 'yearly' }
    ];

    return (
        <div>
            {(BillingReducer?.selectedAutoBills || []).length > 0 && (
                <div className="bg-white rounded-xl shadow-lg p-6">
                    <div className="flex items-center gap-2 mb-4">
                        <Zap className="text-purple-600" size={20} />
                        <h2 className="text-xl font-semibold text-gray-800">Auto Billing Schedule</h2>
                    </div>
                    {BillingReducer?.selectedAutoBills?.map((autoBill, index) => (
                        <div key={autoBill.id || index} className="grid grid-cols-5 gap-4 mb-4 items-end">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Frequency
                                </label>
                                <select
                                    value={autoBill?.frequency || ''}
                                    onChange={(e) => handleAutoBillChange('selectFrequency', e.target.value, index)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                                >
                                    <option value="">Select Frequency</option>
                                    {frequencyOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Start Date
                                </label>
                                <div className="relative">
                                    <input
                                        type="date"
                                        value={autoBill?.startDate || ''}
                                        onChange={(e) => handleAutoBillChange('changeStartDate', e.target.value, index)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    End Date
                                </label>
                                <div className="relative">
                                    <input
                                        type="date"
                                        value={autoBill?.endDate || ''}
                                        onChange={(e) => handleAutoBillChange('changeEndDate', e.target.value, index)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                                    />
                                </div>
                            </div>

                            <div>
                                <MyInput
                                    onChange={(e) => handleAutoBillChange('changeAmount', e.target.value, index)}
                                    title={'Amount'}
                                    value={autoBill?.amount || ''}
                                />
                            </div>

                            <div className="flex items-center gap-2">
                                <span className="text-lg font-semibold text-gray-800">₹{autoBill?.total || 0}</span>
                                <button
                                    onClick={() => handleAutoBillChange('removeAutoBill', false, index)}
                                    className="text-red-500 hover:text-red-700"
                                >
                                    <Trash2 size={16} />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
